import React, { useEffect } from "react";
import { Modal, Form, Button, Typography, App } from "antd";
import { useDispatch, useSelector } from "react-redux";
import InputField from "../../../components/Input/Input";
import {
  createOrUpdateDesignation,
  fetchDesignationsList,
} from "../designationsThunks";
import {
  setSelectedDesignation,
  setIsEditDesignation,
} from "../designationsSlice";

const { Title } = Typography;

const DesignationFormModal = ({ open, onClose, onSuccess }) => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { isEditDesignation, selectedDesignation } = useSelector(
    (state) => state.designations
  );

  useEffect(() => {
    if (isEditDesignation && selectedDesignation) {
      form.setFieldsValue(selectedDesignation);
    } else {
      form.resetFields();
    }
  }, [isEditDesignation, selectedDesignation, open]);

  const handleSave = async (values) => {
    try {
      const res = await dispatch(
        createOrUpdateDesignation({
          designation_name: values.designation_name,
          designation_id: selectedDesignation?.designation_id || 0,
          action: isEditDesignation ? "update" : "create",
        })
      ).unwrap();

      modal.success({
        title: isEditDesignation
          ? "Designation updated successfully"
          : "Designation created successfully",
      });

      dispatch(fetchDesignationsList());
      dispatch(setSelectedDesignation(null));
      dispatch(setIsEditDesignation(false));

      // 🔥 Notify parent immediately
      onSuccess?.(values.designation_name.trim());
      onClose();
    } catch (error) {
      modal.warning({ title: error.message || "Save failed" });
    }
  };

  return (
    <Modal
      open={open}
      title={isEditDesignation ? "Edit Designation" : "Add Designation"}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSave}>
        <Form.Item
          label="Designation Name"
          name="designation_name"
          rules={[{ required: true, message: "Designation is required" }]}
        >
          <InputField placeholder="Enter Designation Name" />
        </Form.Item>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" htmlType="submit">
            {isEditDesignation ? "Update" : "Save"}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default DesignationFormModal;
